<template>
  <div class="draft mr-bt-table">
    <Table header="จัดการบันทึกฉบับร่าง" v-bind:columns="column_table">
      
      <template slot="search-box">
        <div class="col-sm-12">
          <section class="panel panel-default">
            <div class="panel-heading">
              <h4>ค้นหาข้อมูล</h4>
            </div>

            <div class="panel-body clearfix">
              <div class="form-group pull-in">
                
                <div class="col-sm-12 col-xs-12 clearfix">
                  <div class="col-md-3 col-xs-5">
                    <div class="input-group">
                      <DatePickerTH type="past" name="start_date" v-model="search.start_date" />
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </div>
                  </div>

                  <div class="col-md-1 col-xs-2">
                    <span class="input-group-addon nobd-nobg">-</span>
                  </div>

                  <div class="col-md-3 col-xs-5">
                    <div class="input-group">
                      <DatePickerTH type="past" name="end_date" v-model="search.end_date" />
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </div>
                  </div>

                  <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-center-m">
                    <button
                      type="button"
                      class="btn btn-default button-mt-sh10"
                      @click="searchReport()"
                    >
                      <i class="glyphicon glyphicon-search"></i> ค้นหาข้อมูล
                    </button>

                    <download-excel
                      class="btn btn-dark button-mt-sh10"
                      style="margin-left:20px;"
                      :data="results"
                      :fields="json_fields"
                      worksheet="report"
                      name="filename.xls"
                    >
                      <i class="fas fa-file"></i> EXPORT EXCEL
                    </download-excel>
                  </div>
                </div>

              </div>
            </div>
          </section>
        </div>
      </template>

      <template slot="group">
        <ul class="nav nav-pills tab_panel">
          <li class="active">
            <a data-toggle="tab" href="#typePersonal" @click="group_type=1" >
              <span class="text-dark">ประเภทบุคคล</span>
            </a>
          </li>
          <li>
            <a data-toggle="tab" href="#typeGrop" @click="group_type=2" >
              <span class="text-dark"> ประเภทกลุ่ม</span>
            </a>
          </li>
        </ul>
      </template>

      <template slot="main">
        <tr v-if="group_type == 1" v-for="result in results">
          <td>{{ formatDockDateTimeTh(result.createdTime) }}</td>
          <td>{{ (result.applicationId != null) ? result.applicationId : result.quotationId }}</td>
          <td>{{ result.firstName }} {{ result.lastName }}</td>
          <td>{{ result.planName }}</td>
          <td>{{ (result.sumInsured) }}</td>
          <td>{{ (result.grossPremium != null) ? numberWithCommas(result.grossPremium) : '' }}</td>
          <td>{{ (result.applicationId != null) ? 'ใบคำขอ' : 'ใบเสนอราคา' }}</td>
          <td>
            <router-link
              v-if="result.applicationId != null"
              :to="'/insurance_personal/'+result.applicationId"
            >
              <button type="button" class="btn btn-info">
                <i class="fa fa-pencil"></i> ทำรายการต่อ
              </button>
            </router-link>
            <router-link v-else :to="'/quotation_personal/'+result.quotationId">
              <button type="button" class="btn btn-info">
                <i class="fa fa-pencil"></i> ทำรายการต่อ
              </button>
            </router-link>
          </td>
        </tr>

        <tr v-if="group_type == 2" v-for="result in results">
          <td>{{ formatDockDateTimeTh(result.createdTime) }}</td>
          <td>{{ result.familyId }}</td>
          <td>{{ result.firstName }} {{ result.lastName }}</td>
          <td>{{ (result.familyMembers) }} คน</td>
          <td>{{ (result.sumInsured) }}</td>
          <td>
            <label
              v-if="result.familyDiscountPercent != null"
            >ส่วนลดกลุ่ม {{ (result.familyDiscountPercent) }}%</label>
          </td>
          <td>{{ (result.grossPremium != null) ? numberWithCommas(result.grossPremium) : '' }}</td>
          <td>{{ (result.applicationId != null) ? 'ใบคำขอ' : 'ใบเสนอราคา' }}</td>
          <td>
            <router-link v-if="result.familyId != null" :to="'/insurance_family/'+result.familyId">
              <button type="button" class="btn btn-info">
                <i class="fa fa-pencil"></i> ทำรายการต่อ
              </button>
            </router-link>
            <router-link v-else :to="'/quotation_family/'+result.quotationId">
              <button type="button" class="btn btn-info">
                <i class="fa fa-pencil"></i> ทำรายการต่อ
              </button>
            </router-link>
          </td>
        </tr>

        <tr v-if="results.length==0">
          <td colspan="10">
            <div style="margin: 4em 0px;">ไม่พบข้อมูล</div>
          </td>
        </tr>
      </template>

      <template slot="paginate">
        <PaginateTable
          v-model="pagination"
          :page="pagination.page"
          :per_page="pagination.per_page"
          :last_page="pageNum"
          :total="total"
        ></PaginateTable>
      </template>
    </Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "@/components/Table/Index.vue";
import DatePickerTH from "@/components/Form/DatePickerTH.vue";
import downloadExcel from "vue-json-excel";
import PaginateTable from "@/components/Table/PaginateTable.vue";
import moment from "moment";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "draft",
  data() {
    return {
      columns: {
        type_personal: [
          "วันที่สร้าง",
          "เลขที่ใบเสนอราคา/เลขใบคำขอ",
          "ชื่อ - สกุล",
          "แผนประกัน",
          "ทุนประกัน (บาท)",
          "เบี้ยประกันก่อนภาษีและส่วนลด (บาท)",
          "ประเภท",
          "การดำเนินการ"
        ],
        type_group: [
          "วันที่สร้าง",
          "เลขที่กลุ่ม",
          "ชื่อ - สกุล",
          "แผนประกันกลุ่ม",
          "ทุนประกันรวม (บาท)",
          "ส่วนลด (บาท)",
          "เบี้ยประกันก่อนภาษีและส่วนลด (บาท)",
          "ประเภท",
          "การดำเนินการ"
        ]
      },
      column_table: null,
      group_type: 1,
      pagination: {
        page: 1,
        per_page: 20
      },
      search: {
        start_date: {
          human: moment()
            .subtract(10, "days")
            .format("DD/MM/YYYY"),
          origin: moment()
            .subtract(10, "days")
            .format("YYYY-MM-DD")
        },
        end_date: {
          human: moment().format("DD/MM/YYYY"),
          origin: moment().format("YYYY-MM-DD")
        },
        per_page: 20,
        page: 1
      },
      pageNum: 0,
      total: 0,
      results: [],
      json_fields: {
        เลขใบคำขอ: "applicationId",
        "ชื่อ-สกุล": "firstName",
        วันที่สร้าง: "createdTime",
        "ทุนประกัน (บาท)": {
          field: "sumInsured",
          callback: value => {
            return value;
            // `Landline Phone - ${value}`;
          }
        },
        "เบี้ยประกันก่อนภาษีและส่วนลด (บาท)": {
          field: "grossPremium",
          callback: value => {
            return value;
          }
        },
        แผนประกัน: "planName",
        สถานะการจัดการกรมธรรม์: {
          field: "policyStatus",
          callback: value => {
            return this.statusPolicy(value);
          }
        }
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ]
    };
  },
  watch: {
    pagination: function(val) {
      this.init();
    },
    group_type: function(val) {
      this.searchReport();
    }
  },
  computed: {
    ...mapGetters([
      "statusPolicy",
      "env",
      "numberWithCommas",
      "showTimestamp",
      "formatDockDateTimeTh"
    ])
  },
  components: {
    Table,
    DatePickerTH,
    downloadExcel,
    PaginateTable
  },
  mounted() {
    $('input[name="start_date"]').val(this.search.start_date.human);
    $('input[name="end_date"]').val(this.search.end_date.human);
    this.init();
  },
  methods: {
    searchReport() {
      this.pagination.page = 1;
      this.init();
    },
    columnTable() {
      if (this.group_type == 1) {
        this.column_table = this.columns.type_personal;
      } else {
        this.column_table = this.columns.type_group;
      }
    },
    init() {
      const CALL_API = this.env.VUE_APP_PATH_API;
      const CALL_SERVICE =
        this.group_type == 1 ? "report-draft" : "family-report-draft";

      var search = {
        start_date: this.search.start_date.origin,
        end_date: this.search.end_date.origin,
        page: this.pagination.page,
        per_page: this.pagination.per_page
      };

      this.columnTable();

      if (this.$session.get("chili").auth_from == "tvi") {
        search.staffid = "08010";
      }

      this.$http
        .get(`${CALL_API}${CALL_SERVICE}`, {
          params: search,
          headers: {
            Authorization: "Bearer " + this.$session.get("chili").access_token,
            "x-auth-from": this.$session.get("chili").auth_from
          }
        })
        .then(
          response => {
            this.results = response.body.result.report;
            this.pageNum = response.body.result.pageNum;
            this.total = response.body.result.total;
          },
          response => {
            if (response.body.statusCode == 400) {
              if (response.body.message == "Invalid data from db") {
                this.results = [];
                this.pageNum = 0;
                this.total = 0;
              }
            }
          }
        );
    }
  }
};
</script>

<style lang="scss">
</style>
